import { render, staticRenderFns } from "./admin-header.vue?vue&type=template&id=5e2e1019&"
import script from "./admin-header.vue?vue&type=script&lang=js&"
export * from "./admin-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports